import { RevisionHistoryDialogCtrl } from '~src/revisionHistory/controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '~src/ts/helpers/ActionContext';
import { Set } from '~src/ts/models/Set';
import { IWorkbookRevision } from '~src/revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';
import { IActionButton } from '~src/commonInfra/contentActions/ActionPanelInterfaces';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { PreviewWorkbookRevisionActionInstance } from '../services/PreviewWorkbookRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext,
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { ResultHelper } from '~src/httpClient/utils/ResultHelper';

export namespace RevisionActionWorkbook {
  export function getWorkbookRevisionActionButtonsAngular(): IActionButton<IWorkbookRevision, {}>[] {
    return [
      previewWorkbookRevisionActionAngular(),
      deleteWorkbookRevisionActionAngular(),
      RevisionActions.downloadContentRevisionActionAngular()
    ];
  }

  export function getWorkbookRevisionActionButtons(): RevisionHistoryActionButton<IWorkbookRevision>[] {
    return [
      previewWorkbookRevisionAction(),
      deleteWorkbookRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
  }

  // action button factories
  function previewWorkbookRevisionAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'preview',
      translate: 'preview_action',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        PreviewWorkbookRevisionActionInstance.openPreview(context.selectedItem);
      }
    };
  }
  function previewWorkbookRevisionActionAngular(): IActionButton<IWorkbookRevision, {}> {
    return {
      name: 'preview',
      translate: 'preview_action',
      isAvailable: (items: Set<IWorkbookRevision>) => true,
      execute: (items: Set<IWorkbookRevision>) => {
        PreviewWorkbookRevisionActionInstance.openPreview(items.first());
      }
    };
  }

  function deleteWorkbookRevisionAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        DeleteRevisionAction.showDeleteWorkbookRevisionDialog(context.selectedItem, context);
      }
    };
  }
  function deleteWorkbookRevisionActionAngular(): IActionButton<IWorkbookRevision, {}> {
    return {
      name: 'delete',
      translate: 'delete_action',
      isAvailable: (items: Set<IWorkbookRevision>) => items.size() === 1,
      execute: (items: Set<IWorkbookRevision>, context: IActionContext) => {
        const scope = <RevisionHistoryDialogCtrl.Scope>context.scope;
        DeleteRevisionAction.showDeleteWorkbookRevisionDialog(items.first(), context).then(() => scope.refreshContent());
      }
    };
  }
}
